// disable console functions when not in DEV and fix a no-breaker for browsers that don't have console
// [from html5boilerplate]

;if (undefined === window.DEV) window.DEV = /(vcap\.me|\.dev)\//.test(window.location.href) || /debug/.test(window.location.hash);

(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        if (!window.DEV || !console[method]) {
            console[method] = noop;
        }
    }
}());
